import React from 'react';
import './Style.css';

const ScheduleTableStates = ({ loading, error }) => {
    if (loading) {
        return (
            <div className="schedule-table-loading">
                <div className="schedule-table-loading-spinner"></div>
                <p className="schedule-table-loading-text">Loading schedule interviews...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="schedule-table-error">
                <div className="schedule-table-error-icon">
                    <svg className="w-12 h-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </div>
                <h3 className="schedule-table-error-title">Unable to Load Schedule Interviews</h3>
                <p className="schedule-table-error-text">{error}</p>
            </div>
        );
    }

    return null;
};

export default ScheduleTableStates;

